const ACTIVITY_TEMPLATES_LIST_PATH = "/clinician-portal/activity-templates";

function currentOrigin(): string {
  return typeof window === "undefined"
    ? "http://localhost"
    : window.location.origin;
}

export function safeActivityTemplatesReturnTo(value?: string | null): string {
  if (!value) return ACTIVITY_TEMPLATES_LIST_PATH;

  try {
    const url = new URL(value, currentOrigin());
    if (
      url.origin !== currentOrigin() ||
      url.pathname !== ACTIVITY_TEMPLATES_LIST_PATH
    ) {
      return ACTIVITY_TEMPLATES_LIST_PATH;
    }

    url.searchParams.delete("clinicianCode");
    return `${url.pathname}${url.search}`;
  } catch {
    return ACTIVITY_TEMPLATES_LIST_PATH;
  }
}

export function activityTemplatesReturnToFromSearch(search: string): string {
  return safeActivityTemplatesReturnTo(
    new URLSearchParams(search).get("returnTo"),
  );
}

export function withActivityTemplatesReturnTo(
  path: string,
  returnTo: string,
): string {
  const url = new URL(path, currentOrigin());
  url.searchParams.set("returnTo", safeActivityTemplatesReturnTo(returnTo));
  return `${url.pathname}${url.search}`;
}

export function currentActivityTemplatesListPath(search: string): string {
  return safeActivityTemplatesReturnTo(
    `${ACTIVITY_TEMPLATES_LIST_PATH}${search}`,
  );
}
